function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.065 10.297c0-3.438 2.759-6.232 6.172-6.232 3.412 0 6.172 2.794 6.172 6.232a6.246 6.246 0 01-2.819 5.233v2.083a.677.677 0 01-.677.677H7.56a.677.677 0 01-.677-.677V15.53a6.246 6.246 0 01-2.818-5.233zm4.173 4.439v2.2h3.997v-2.2a4.882 4.882 0 002.819-4.44c0-2.693-2.157-4.877-4.817-4.877s-4.818 2.184-4.818 4.878a4.882 4.882 0 002.819 4.439z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.226 10.839a4.065 4.065 0 00-4.065-4.065.677.677 0 000 1.355 2.71 2.71 0 012.71 2.71.677.677 0 001.355 0z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M7.452 19.645h5.419a.677.677 0 110 1.355h-5.42a.677.677 0 010-1.355zm1.354 2.032h2.71a.677.677 0 110 1.355h-2.71a.677.677 0 010-1.355zM10.161 0c.374 0 .678.303.678.677v1.355a.677.677 0 01-1.355 0V.677c0-.374.303-.677.677-.677zm8.212 2.908a.677.677 0 010 .958l-.959.958a.677.677 0 11-.958-.958l.958-.958a.677.677 0 01.959 0zM21 10.161a.677.677 0 01-.677.678h-1.355a.677.677 0 010-1.355h1.355c.374 0 .677.303.677.677zm-18.29 0a.677.677 0 01-.678.678H.677a.677.677 0 010-1.355h1.355c.374 0 .678.303.678.677zm1.437-5.337a.677.677 0 01-.958 0l-.958-.958a.677.677 0 01.958-.958l.958.958a.677.677 0 010 .958z"
}));

function SvgLightbulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24
  }, props), _ref);
}

export default SvgLightbulb;